
    import './styles.scoped.css';
    export default {
  "dropdown-footer": "awsui_dropdown-footer_vm8qf_1jwa9_9",
  "dropdown-content": "awsui_dropdown-content_vm8qf_1jwa9_14",
  "token-field-container": "awsui_token-field-container_vm8qf_1jwa9_18",
  "token-field": "awsui_token-field_vm8qf_1jwa9_18",
  "token-field-disabled": "awsui_token-field-disabled_vm8qf_1jwa9_54",
  "token-field-readonly": "awsui_token-field-readonly_vm8qf_1jwa9_62",
  "token-field-invalid": "awsui_token-field-invalid_vm8qf_1jwa9_68",
  "token-field-warning": "awsui_token-field-warning_vm8qf_1jwa9_80",
  "grouped": "awsui_grouped_vm8qf_1jwa9_92",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_vm8qf_1jwa9_99",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_vm8qf_1jwa9_103",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_vm8qf_1jwa9_109",
  "grouped-vertical-first": "awsui_grouped-vertical-first_vm8qf_1jwa9_113",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_vm8qf_1jwa9_117",
  "grouped-vertical-last": "awsui_grouped-vertical-last_vm8qf_1jwa9_123",
  "grouped-with-action": "awsui_grouped-with-action_vm8qf_1jwa9_127",
  "grouped-with-error": "awsui_grouped-with-error_vm8qf_1jwa9_131",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_vm8qf_1jwa9_159",
  "grouped-vertical-only": "awsui_grouped-vertical-only_vm8qf_1jwa9_159",
  "grouped-with-warning": "awsui_grouped-with-warning_vm8qf_1jwa9_165",
  "grouped-vertical": "awsui_grouped-vertical_vm8qf_1jwa9_113",
  "grouped-horizontal": "awsui_grouped-horizontal_vm8qf_1jwa9_99",
  "token-field-icon": "awsui_token-field-icon_vm8qf_1jwa9_226",
  "token-list": "awsui_token-list_vm8qf_1jwa9_232",
  "inline-tokens": "awsui_inline-tokens_vm8qf_1jwa9_246",
  "token-list-item": "awsui_token-list-item_vm8qf_1jwa9_250",
  "token-input-wrapper": "awsui_token-input-wrapper_vm8qf_1jwa9_254",
  "token-overflow": "awsui_token-overflow_vm8qf_1jwa9_261",
  "token-overflow-trigger": "awsui_token-overflow-trigger_vm8qf_1jwa9_265",
  "overflow-dropdown": "awsui_overflow-dropdown_vm8qf_1jwa9_269",
  "overflow-dropdown-item": "awsui_overflow-dropdown-item_vm8qf_1jwa9_278",
  "measurement-container": "awsui_measurement-container_vm8qf_1jwa9_284",
  "measurement-token": "awsui_measurement-token_vm8qf_1jwa9_297"
};
  